<div class="list-view-wrapper w-100" *ngIf="rows.length > 0; else emptyState">
    <div class="table-responsive list-view-table-container">
        <table mat-table [dataSource]="rows" class="table list-view-table alternateColor">
            <ng-container matColumnDef="time">
                <th mat-header-cell *matHeaderCellDef>{{ 'serviceSchedule.listViewTime' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.time }}</td>
            </ng-container>

            <ng-container matColumnDef="customer">
                <th mat-header-cell *matHeaderCellDef>{{ 'serviceSchedule.listViewCustomer' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.customer }}</td>
            </ng-container>

            <ng-container matColumnDef="vehicle">
                <th mat-header-cell *matHeaderCellDef>{{ 'serviceSchedule.listViewVehicle' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.vehicle }}</td>
            </ng-container>

            <ng-container matColumnDef="orderRef">
                <th mat-header-cell *matHeaderCellDef>{{ 'parts.orderRef' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.orderRef }}</td>
            </ng-container>

            <ng-container matColumnDef="dealerOrd">
                <th mat-header-cell *matHeaderCellDef>{{ 'parts.dealerOrder' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.dealerOrd }}</td>
            </ng-container>

            <ng-container matColumnDef="serviceDetails">
                <th mat-header-cell *matHeaderCellDef>{{ 'serviceSchedule.listViewServiceDetails' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.serviceDetails }}</td>
            </ng-container>

            <ng-container matColumnDef="advisor">
                <th mat-header-cell *matHeaderCellDef>{{ (department === 'SALES' ? 'serviceSchedule.listViewSalesConsultant' :
                    'serviceSchedule.listViewAdvisor') | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.advisor }}</td>
            </ng-container>

            <ng-container matColumnDef="type">
                <th mat-header-cell *matHeaderCellDef>{{ 'serviceSchedule.listViewType' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.type }}</td>
            </ng-container>

            <ng-container matColumnDef="duration">
                <th mat-header-cell *matHeaderCellDef>{{ 'serviceSchedule.listViewDuration' | translate }}</th>
                <td mat-cell *matCellDef="let row">{{ row.duration }}</td>
            </ng-container>

            <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let row">
                    <button mat-icon-button style="padding: 0px; height: 20px; width: 20px;"
                        (click)="openAppointmentSummaryDialog(row.appointment)">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns" (click)="openAppointmentSummaryDialog(row.appointment)">
            </tr>
        </table>
    </div>
</div>

<ng-template #emptyState>
    <div class="no-appointments">
        <mat-icon class="mat-icon">info_outline</mat-icon>
        <span class="label">{{ 'serviceSchedule.thereAreNoAppointmentsScheduledForTheDay' | translate }}</span>
    </div>
</ng-template>